"use client";

import * as React from "react";

/**
 * Register the ModernATC service worker for every app session instead of only
 * when a student opens Push Notification settings. The current worker handles
 * push events and notification clicks; registering it globally also gives the
 * installed PWA a consistent service-worker lifecycle on iPad and other
 * platforms without caching authenticated HTML.
 */
export function ServiceWorkerRegistrar() {
  React.useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    void navigator.serviceWorker.register("/sw.js").catch(() => {
      // Registration failure should never block the training app. The user can
      // continue online and a later navigation will try again.
    });
  }, []);

  return null;
}
